namespace Solovis.Reports.Parameters.ParameterControlHelper {

    export interface HandleSetParameterValueMoreOptions {
        suppressChangeNotification?: boolean;        
    }

    /**
     * paramControlType is the type of the parameter control. setParamDataCallback is a function(paramValue)
     * that will be called with the loaded parameter value (assumed to be defined on paramControlType.
     * @param paramControlInstance
     * @param paramControlType
     * @param setParamDataMethod
     * @param newValue
     * @param more
     */
    export function handleSetParameterValue(
        paramControlInstance,
        paramControlType,
        setParamDataMethod,
        newValue,
        more: HandleSetParameterValueMoreOptions,
        portalServices: Solovis.Portal.IPortalServices = null
    ): void {
        var suppressChangeNotification = more ? (more.suppressChangeNotification ? true : false) : false;
        var needsPreload = ParameterControlHelper.valueNeedsPreload(paramControlType, newValue);
      
        if (!portalServices) {
            portalServices = new Solovis.Portal.SitePortalServices();
        }

        if (needsPreload) {
            paramControlType.preload(
                newValue,
                function (loadedValue, success) {
                    if (success) {
                        setParamDataMethod.call(paramControlInstance, loadedValue);
                    }
                    else {
                        setParamDataMethod.call(paramControlInstance, null);
                    }
                    if (!suppressChangeNotification) {
                        paramControlInstance.notifyParameterValueChanged();
                    }
                },
                portalServices);
        }
        else {
            setParamDataMethod.call(paramControlInstance, newValue);
            if (!suppressChangeNotification) {
                paramControlInstance.notifyParameterValueChanged();
            }
        }
    }


    /**
     * Determine if a param value needs to be preloaded using the preload/shouldPreload optional static function on paramControlType.
     * @param paramControlType
     * @param paramValue
     */
    export function valueNeedsPreload(paramControlType, paramValue): boolean {
        if (paramControlType.preload) {
            // preload is an optional static method on the paramEditControlType.
            if (paramValue !== null && (!paramControlType.shouldPreload || paramControlType.shouldPreload(paramValue))) {
                // If the paramControlType has preload method and value is not null, we will need to preload the value (unless
                // the paramControlType is able to tell us that preloading is not needed).                                
                return true;
            }
        }

        return false;
    }
}